import { useMemo } from 'react';

import { PageContainer } from 'components';
import { selectSelectedCountryId } from 'store/country/countrySlice';
import { useAppSelector } from 'store';
import { useGetPaymentTncQuery } from 'store/terms-and-conditions/termsAPI';
import DOMPurify from 'dompurify';

import { MainContainer, Quote } from '@britishcouncil/react-solas-ors3';

import { useMyRegistrationsData } from '../my-registrations/useMyRegistrationsData';

import { PaymentsList } from './components/PaymentsList';

export const MyRegistrationsPayments = () => {
  const countryId = useAppSelector(selectSelectedCountryId);
  const { data: paymentTerms } = useGetPaymentTncQuery(countryId);
  const { isLoading, data: summary } = useMyRegistrationsData();

  const unpaidRegistrations = useMemo(
    () => summary?.payments.filter((x) => x.balance < 0).length ?? 0,
    [summary?.payments]
  );

  return (
    <>
      <MainContainer>
        <h1>Payments</h1>
      </MainContainer>

      <PageContainer loading={isLoading}>
        {summary && (
          <>
            {unpaidRegistrations > 0 ? (
              <>
                <h2>You have {unpaidRegistrations} unpaid registrations</h2>
                {paymentTerms && (
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(paymentTerms?.text || '') }} />
                )}
              </>
            ) : (
              <h2>You have no unpaid registrations</h2>
            )}
            {summary?.payments.length === 0 && (
              <Quote title="Note" intent="info">
                You didn't make any payment yet
              </Quote>
            )}
            <PaymentsList payments={summary?.payments ?? []} />
          </>
        )}
      </PageContainer>
    </>
  );
};
